// removed by extract-text-webpack-plugin
module.exports = {"zhThemeColor":"#f76563","enThemeColor":"#295BFF"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/variables.scss
// module id = syC2
// module chunks = 17